import { authenticationTokenSelector } from '@cp/shared/api/core';
import { metaUserAgentSelector } from '@cp/shared/meta';
import React from 'react';
import { useSelector } from 'react-redux';

const DEFAULT_USER_AGENT_VALUE = '';

export const useUserAgent = (): string => {
  const ssrValue = useSelector(metaUserAgentSelector);
  // NOTE: Due to pages caching on server side,
  // we have a problem with different user agent value in SSR and CSR.

  // We can trust user agent value in SSR when user is logged in
  // and, as a result, page caching is turned off
  // and user agent value is not taken from cache
  const authTokenPayload = useSelector(authenticationTokenSelector);
  const useSSRValue = Boolean(authTokenPayload);

  // If we can not trust user agent value, we set it to default value
  const [value, setValue] = React.useState(useSSRValue ? ssrValue : DEFAULT_USER_AGENT_VALUE);

  React.useEffect(() => {
    // We are in case, when SSR user agent value and CSR user agent value is different
    // (page cache was used at SSR)
    if (window.navigator.userAgent !== value) {
      // To avoid react hydration errors, we switching user agent from SSR to CSR value inside use effect,
      // which triggers content rerender using new correct value
      setValue(window.navigator.userAgent);
    }
  }, [value]);

  return value ?? DEFAULT_USER_AGENT_VALUE;
};
